import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'Common/ReactTableWrapper';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { DATE_TIME_FORMAT_FOR_UI } from 'Common/Constants';

export class ProcessedDocumentsTable extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    cogOptions: PropTypes.array.isRequired,
    loading: PropTypes.bool,
  };

  columns = [
    {
      Header: 'User',
      accessor: 'UserMaster.UserName',
      filterable: true,
    },
    {
      Header: 'Created At',
      accessor: 'CreatedDT',
      Cell: ({ value }) =>
        value.isValid() ? value.format(DATE_TIME_FORMAT_FOR_UI) : '',
      filterable: true,
      filterMethod: (filter, row) => {
        const value = row[filter.id].isValid()
          ? row[filter.id].format(DATE_TIME_FORMAT_FOR_UI)
          : '';
        return caseInsensitiveFilter(filter, { ...row, [filter.id]: value });
      },
    },
    {
      Header: 'Completed At',
      accessor: 'CompletedDT',
      Cell: ({ value }) =>
        value.isValid() ? value.format(DATE_TIME_FORMAT_FOR_UI) : '',
      filterable: true,
      filterMethod: (filter, row) => {
        const value = row[filter.id].isValid()
          ? row[filter.id].format(DATE_TIME_FORMAT_FOR_UI)
          : '';
        return caseInsensitiveFilter(filter, { ...row, [filter.id]: value });
      },
    },
    {
      Header: 'Processed Document Type',
      accessor: 'Ref_ProcessedDocumentType.Description',
      filterable: true,
    },
    {
      width: 50,
      sortable: false,
      filterable: false,
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.props.cogOptions,
        });
      },
    },
  ];

  render() {
    return (
      <React.Fragment>
        <ReactTable
          menu="hasCogs"
          saveState={{ tableName: TableNamesEnum.PROCESSED_DOCUMENTS_TABLE }}
          loading={this.props.loading}
          data={this.props.data}
          columns={this.columns}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/processeddocuments/components/ProcessedDocumentsTable.js